import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { useStateContext } from '../../../context/StateContext'

export const useLogin = (AuthContext) => {

  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const { dispatch } = useAuthContext(AuthContext)
  const {apiUrl, hideTestButtons} = useStateContext()
  //const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000'

  const login = async (email, password) => {
    setIsLoading(true)
    setError(null)

    process.env.NODE_ENV === "development" && console.log('Attempting login to:', `${apiUrl}/user/login`);
    
    try {
      const response = await fetch(`${apiUrl}/user/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ email, password })
      });
      
      process.env.NODE_ENV === "development" && console.log('Login response status:', response.status);
      const json = await response.json();
      process.env.NODE_ENV === "development" && console.log('Login response:', { ok: response.ok, status: response.status });

      if (!response.ok) {
        setIsLoading(false);
        process.env.NODE_ENV === "development" && console.error('Login failed:', json.error);
        setError(json.error);
      }
      if (response.ok) {
        process.env.NODE_ENV === "development" && console.log('Login successful');
        // save the user to local storage
        localStorage.setItem('user', JSON.stringify(json));

        // update the auth context
        dispatch({type: 'LOGIN', payload: json});

        // update loading state
        setIsLoading(false);
      }
    } catch (err) {
      process.env.NODE_ENV === "development" && console.error('Login request failed:', {
        message: err.message,
        stack: err.stack,
        apiUrl: apiUrl
      });
      setIsLoading(false);
      setError('Failed to connect to server. Please check if the server is running.');
    }
  }
  const updatePassword = async (newPassword, user) => {
    setIsLoading(true)
    setError(null)

    process.env.NODE_ENV === "development" && console.log("BEGINNING PASSWORD UPDATE")
    try {
      const response = await fetch(`${apiUrl}/user/update-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${user.token}`
        },
        credentials: 'include',
        body: JSON.stringify({ newPassword, user })
      });
      
      // Parse the response JSON
      const json = await response.json();
      process.env.NODE_ENV === "development" && console.log('Password update response:', { ok: response.ok, status: response.status });
      
      // Handle error response
      if (!response.ok) {
        setIsLoading(false);
        process.env.NODE_ENV === "development" && console.error('Password update failed:', json.error);
        setError(json.error);
        return;
      }
      
      // Handle successful response
      if (response.ok) {
        process.env.NODE_ENV === "development" && console.log('Password update successful');
        const doc = {...user, changePassword: false}
        localStorage.setItem('user', JSON.stringify(doc))
        dispatch({type: 'LOGIN', payload: doc})
        setIsLoading(false);
      } 
    } catch (error) {
      process.env.NODE_ENV === "development" && console.error("Password update error:", error);
      setIsLoading(false);
      
      // Use the error message from the error object if available
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError(error.message || 'The password could not be updated.');
      }
    }
  }

  const sendOtp = async (email) => {
    setIsLoading(true)
    setError(null)

    process.env.NODE_ENV === "development" && console.log('Attempting Sending OTP to:', `${apiUrl}/user/send-otp`);
    
    try {
      const response = await fetch(`${apiUrl}/user/send-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ email })
      });
      
      process.env.NODE_ENV === "development" && console.log('Otp response status:', response.status);
      const json = await response.json();
      process.env.NODE_ENV === "development" && console.log('Otp response:', { ok: response.ok, status: response.status });

      if (!response.ok) {
        setIsLoading(false);
        process.env.NODE_ENV === "development" && console.error('Otp Send failed:', json.error);
        setError(json.error);
      }
      if (response.ok) {
        process.env.NODE_ENV === "development" && console.log('Otp Sent successfully');
        setIsLoading(false);
        return { ok: response.ok, status: response.status }
 
      }
    } catch (err) {
      process.env.NODE_ENV === "development" && console.error('Login request failed:', {
        message: err.message,
        stack: err.stack,
        apiUrl: apiUrl
      });
      setIsLoading(false);
      setError('Failed to connect to server. Please check if the server is running.');
    }
  }

  const getOtp = async (email, code) => {
    setIsLoading(true)
    setError(null)

    process.env.NODE_ENV === "development" && console.log(`Attempting veryfying OTP ${code} to:`, `${apiUrl}/user/return-otp`);
    
    try {
      const response = await fetch(`${apiUrl}/user/return-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ email, otp:code })
      });
      
      process.env.NODE_ENV === "development" && console.log('otp return response status:', response.status);
      const json = await response.json();
      process.env.NODE_ENV === "development" && console.log('Return response:', { ok: response.ok, status: response.status });

      if (!response.ok) {
        setIsLoading(false);
        process.env.NODE_ENV === "development" && console.error('Login failed:', json.error);
        setError(json.error);
      }
      if (response.ok) {
        process.env.NODE_ENV === "development" && console.log('Login successful');
        // save the user to local storage
        localStorage.setItem('user', JSON.stringify(json));

        // update the auth context
        dispatch({type: 'LOGIN', payload: json});
        setIsLoading(false);
        return  { ok: response.ok, status: response.status }
        // update loading state
      
      }
    } catch (err) {
      process.env.NODE_ENV === "development" && console.error('Login request failed:', {
        message: err.message,
        stack: err.stack,
        apiUrl: apiUrl
      });
      setIsLoading(false);
      setError('Failed to connect to server. Please check if the server is running.');
    }
  }

  return { login, sendOtp, getOtp, updatePassword, isLoading, error }
}
